import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';

const namespace = 'filterByExternalUsers';

const FilterByExternalUsersModel = {
  namespace,
  state: initialState,
  effects: makeListEffects({
    namespace,
    fetchRoute: 'filterByExternalUsers',
    fetchParams: {
      item: {
        select: 'id,valueSource,fixedValue',
        notSelectSearch: ['valueSource'],
        expand: {
          form: {
            select: 'name',
          },
          field: {
            select: 'displayText',
          },
          variable: {
            select: 'internalName',
          },
        },
      },
    },
  }),
  reducers: makeListReducers({
    initialPagination,
    initialState,
  }),
};

export default FilterByExternalUsersModel;
